import apollo from '@/graphql'
import { Message } from 'element-ui'
import router from '@/router'

import AdvertiserDetailsQuery from '@/graphql/advertiser/AdvertiserDetailsQuery.gql'
import AdvertisersQuery from '@/graphql/advertiser/AdvertisersQuery.gql'
import CreateAdvertiser from '@/graphql/advertiser/CreateAdvertiser.gql'
import SaveAdvertiserDetails from '@/graphql/advertiser/SaveAdvertiserDetails.gql'

function loadAdvertiserDetails({ commit }, { id, startDate, endDate }) {
  commit('setFilters', { startDate, endDate })
  apollo.defaultClient.query({
    fetchPolicy: 'network-only',
    query: AdvertiserDetailsQuery,
    variables: { id: +id },
  }).then(({ data: { advertiserDetails } }) => {
    commit('setAdvertiserDetails', advertiserDetails)
    commit('setEditableAdvertiserFields', advertiserDetails)
  })
}

function loadAdvertisers({ commit }) {
  apollo.defaultClient.query({
    fetchPolicy: 'network-only',
    query: AdvertisersQuery,
  }).then(({ data: { advertisers } }) => {
    commit('setAdvertisers', advertisers)
  })
}

function saveAdvertiserDetails({ state }) {
  apollo.defaultClient.mutate({
    mutation: SaveAdvertiserDetails,
    variables: { fields: state.editableAdvertiserFields },
  }).then(({ data: { saveAdvertiserDetails: { id } } }) => {
    Message({ message: 'Changes saved', type: 'success', center: false })
    router.push(`/advertiser/${id}`)
  }).catch((err) => {
    Message.error(err.message)
  })
}

function createAdvertiser({ state }) {
  apollo.defaultClient.mutate({
    mutation: CreateAdvertiser,
    variables: { fields: state.editableAdvertiserFields },
  }).then(({ data: { createAdvertiser: { id } } }) => {
    Message({ message: 'Changes saved', type: 'success', center: false })
    router.push(`/advertiser/${id}`)
  }).catch((err) => {
    Message.error(err.message)
  })
}

// saveAdvertiserDetails

export default {
  loadAdvertiserDetails,
  loadAdvertisers,
  saveAdvertiserDetails,
  createAdvertiser,
}



// WEBPACK FOOTER //
// ./src/store/modules/advertiser/advertiser.actions.js